export default __webpack_public_path__ + "static/avatar-diagram-cdda054d453e2d9351242738610f1f8a.png";